import { render, staticRenderFns } from "./CustomerOrdersWebOrderLink.vue?vue&type=template&id=73b11e5d&"
import script from "./CustomerOrdersWebOrderLink.vue?vue&type=script&lang=js&"
export * from "./CustomerOrdersWebOrderLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports